import { FC } from 'react'
import cx from 'classnames'
import { SliderProps } from '@vidstack/react'

import { BlockTitleProps } from '../BlockTitle'
import { RichTextProps } from '../RichText'
import { ActionButtonProps } from '../ActionButton'
import { IllustrationProps } from '../Illustration'

import * as SC from './styled'

export type IllustrationCarouselProps = {
  className?: string
  blockTitleProps?: BlockTitleProps
  illustrations?: IllustrationProps[]
  richTextProps?: RichTextProps
  actionButtonProps?: ActionButtonProps
  sliderProps?: Partial<SliderProps>
}

const IllustrationCarousel: FC<IllustrationCarouselProps> = ({
  className,
  blockTitleProps,
  illustrations,
  richTextProps,
  actionButtonProps,
  sliderProps,
}) => {
  return illustrations && illustrations.length > 0 ? (
    <SC.Container className={cx('IllustrationCarousel', className)}>
      {blockTitleProps && <SC._BlockTitle {...blockTitleProps} />}
      <SC.Wrapper>
        <SC._Slider
          slides={illustrations.map((illustration, index) => {
            return {
              forcedRatio: {
                ratio:
                  ((illustration.pictureProps.imageProps?.width as number) ??
                    1) /
                  ((illustration.pictureProps.imageProps?.height as number) ??
                    1),
                heightReference: 600,
                breakpoint: 'desktop',
              },
              node: <SC._Illustration key={index} {...illustration} />,
            }
          })}
          isForDesktop={true}
          keenOptions={{
            drag: true,
            slides: { perView: 1.2, spacing: 16 },
            defaultAnimation: {
              duration: 300,
            },
            breakpoints: {
              // 600 as in sizes
              '(min-width: 37.5em)': {
                slides: { perView: 1.75, spacing: 16 },
              },
              // // 900 as in sizes
              '(min-width: 56.25em)': {
                slides: { perView: 'auto', spacing: 16 },
              },
            },
          }}
          {...sliderProps}
        />
        {(richTextProps || actionButtonProps) && (
          <SC.Content>
            {richTextProps && <SC._RichText {...richTextProps} />}
            {actionButtonProps && <SC._ActionButton {...actionButtonProps} />}
          </SC.Content>
        )}
      </SC.Wrapper>
    </SC.Container>
  ) : null
}

export default IllustrationCarousel
